export const STRIPE_SCRIPT_LOAD_FAILED_MESSAGE = 'Failed to load Stripe.js';
export function isStripeScriptLoadFailure(error) {
    return error instanceof Error && error.message === STRIPE_SCRIPT_LOAD_FAILED_MESSAGE;
}
export function buildStripeLoadFailedLog(param) {
    let { online, pathname } = param;
    return {
        type: 'stripeLoadFailed',
        online,
        pathname
    };
}
